<script>
    import Common from "../common/index";
    // import * as commonServer from "../../../../../../api/common";
    export default {
        name: "changjing",
        mixins: [Common],
        props: {
            navId: [String,Number]
        },
        watch: {
            show:{
                handler(vl) {
                    if (vl) {
                        this.init()
                    }
                },
                deep: true,
                immediate: true
            },
            navId(vl){
                if(vl) this.init()
            }
        },
        data(){
            return {
                type: 'scenes',
                config: [
                    {
                        type: 'SearchBox',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'UploadBtn',
                        value: '',
                        fixed: true
                    },
                    {
                        type: 'TypeBtn',
                        value: '',
                        selected: '2',
                        fixed: true
                    },
                    {
                        type: 'CatalogType',
                        value: '',
                        selected: '',
                        fixed: true
                    },
                    {
                        type: 'TypeList',
                        form: [
                            {
                                title: '场景类型',
                                data: [
                                    // {url: this.$images.contents.datu, love: false},
                                    // {url: this.$images.contents.datu, love: true},
                                    // {url: this.$images.contents.datu, love: false},
                                    // {url: this.$images.contents.datu, love: false},
                                    // {url: this.$images.contents.datu, love: false},
                                    // {url: this.$images.contents.datu, love: false},
                                ],
                                column: 2,
                            }
                        ],
                        selected: [0]
                    },
                    {
                        type: 'SearchList',
                        value: ''
                    },
                    {
                        type: 'MoreBtn',
                        value: ''
                    },
                ]
            }
        },
        methods:{
            onSearchBox(search){
                this.search = search
                // this.flashData()
            }
            // init(){
            //     this.flashData()
            // },
            // async flashData(){
            //     let index = this.getIndexByType('TypeList')
            //     // 获取所有的动画一级目录
            //     const res = await commonServer.default[this.getResourceCategoryTree]({
            //         clientsId: this.$store.state.initConfig.school_id,
            //         sort: this.type
            //     })
            //     console.log('获取动画列表分类==>', res.data)
            //     this.config[index].selected = []
            //     this.config[index].form = res.data.filter(v=>v.parent_id === 0).map(q=>{
            //         return {
            //             title: q.name,
            //             column: 2,
            //             data: [],
            //             ...q,
            //         }
            //     })
            //
            //     let obj = {}
            //     this.config[index].form.map(async (v, i)=>{
            //         obj = {
            //             clientsId: this.$store.state.initConfig.school_id,
            //             sort: this.type,
            //             categoryId: v.id,
            //             scenesStageId: this.navId
            //         }
            //         if(this.search){
            //             obj.search = this.search
            //         }
            //
            //         // 数据请求地址 & 参数
            //         v.apiConfig = {
            //             params: obj,
            //             request: commonServer.default[this.getResourceList]
            //         }
            //
            //         if(i===0) {
            //             let data = await commonServer.default[this.getResourceList](obj)
            //             let url = ''
            //             v.data = data.items.map(q => {
            //                 url = q.attributes.resources && q.attributes.resources.url
            //                 if (q.attributes && q.attributes.cover) url = q.attributes.cover
            //                 if (q.attributes.h5_remote) url = q.attributes
            //                 return {
            //                     url,
            //                     ...q
            //                 }
            //             })
            //
            //             // 如果第一个数据有值默认选中第一个展开
            //             if(v.data && v.data.length>0) {
            //                 this.config[index].selected = [i]
            //             }
            //         }
            //
            //         // 数据请求地址 & 参数
            //         v.apiConfig = {
            //             params: obj,
            //             request: commonServer.default[this.getResourceList]
            //         }
            //     })
            // },
        }
    }
</script>
